import React from 'react';
import { Platform, ViewProps } from 'react-native';
import styled from 'styled-components/native';

const StyledCard = styled.View`
  background-color: white;
  border-radius: 24px;
  shadow-color: #111111;
  shadow-offset: 0 16px;
  shadow-opacity: 0.1;
  shadow-radius: 48px;
  ${Platform.OS === 'web'
    ? '-webkit-filter: opacity(1);'
    : ''}// safari browser shadow fix
` as React.FC<ViewProps>;

const Card: React.FC<ViewProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

export default Card;
